"use client";
import * as React from "react";
const SvgShoppingCartFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.8 12.8a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0-.01-3.2M0 .8c0 .44.36.8.8.8h.8l2.88 6.07L3.4 9.62A1.6 1.6 0 0 0 4.8 12h8.8c.44 0 .8-.36.8-.8s-.36-.8-.8-.8H4.8l.88-1.6h5.96c.6 0 1.12-.33 1.4-.82l2.86-5.2a.8.8 0 0 0-.7-1.18H3.37L2.83.46A.8.8 0 0 0 2.11 0H.8a.8.8 0 0 0-.8.8m12.8 12a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2" }));
export {
  SvgShoppingCartFilled as default
};
